import { useEffect,useContext , useState, useRef } from 'react';
import { ButtonLoader } from '../../utils/Loaders/ButtonLoader';
import { AppContext } from '../../../AppContextProvider';
import Charges from './photovoltaique/Charges';
import Histogram from '../../utils/Histogram/Histogramme';
import { BrowserView, MobileView,isBrowser,isMobile } from 'react-device-detect';
import { useFetch } from '../../api/FetchApiData';
import { MediaUrl } from '../../utils/media/Media';
import { VitrineContext } from '../VitrineContext';
import { useWindowHeight } from '@react-hook/window-size';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clear_filters from '../../icons/clear-filter.png';

if (isMobile)
    import('./filtres_mob.css').then(() => {});
else
    import('./filtres.css').then(() => {});


const RayonCheckBox = ({label,index,rayon,setRayon,rayons,clearfilters,filters,setFileters,img={disp:false,src:''}})=>
{

    let margintop = '2px';
    margintop = isBrowser ? '13px' : '13px';

    const MarkedRayon = (text)=>{
        const elements = text.split('*');
        if(elements.length>1)
        {
            return(
                    <div style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>
                        <label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'100%'}}>{elements[0]}</label>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block',fontSize:'xx-small',color:'gray'}}>{elements[1]}</label>
                    </div>
            );
        }
        else{
            return(<label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>{text}</label>);
        }
    };

    const HandleRayonClick = (index)=>
    {
        const clicked = rayons[index];
        const newRayon = rayon.name === clicked.name ? rayon : clicked;
        setRayon(newRayon);
        if(rayon.name !== clicked.name)
            clearfilters();
    }

    return(
    <div key={label} style={{position:'relative',width:'100%',textAlign:'left',marginTop:'5px'}}>
        <img src={img.src} style={{display:'inline-block',width:'40px',height:'40px',borderRadius:'20px',verticalAlign:'middle',marginRight:'10px'}}/>
        {/*<label style={{display:'inline-block',verticalAlign:'middle',wordWrap:'break-word',maxWidth:'50%'}}>{label}</label>*/}
        {MarkedRayon(label)}
        <input style={{position:'absolute',right:'10px',top:margintop,verticalAlign:'middle',width:'15px'}} checked={label===rayon.name} onChange={()=>{HandleRayonClick(index)}} type='checkbox' />
    </div>);
}


export default function Filtres({close=()=>{}})
{
    const [FilterBtn,setFilterBtn] = useState({display:'block',text:'-'});
    const [loading,setLoading] = useState(false);
    const [rayon,setRayon] = useState({categories:[]});
    const [Categories,setCategories] = useState([]);
    const [manufacturers,setManufacturers] = useState([]);
    const [displays,setDisplays] = useState({category:'none',manufacturer:'none'});
    const [AppState,setAppState] = useContext(AppContext);
    const fetchData = useFetch({AppState,setAppState});
    const [rayons,setRayons] = useState([]);
    const [histograms,setHistograms] = useState([]);
    const [filters,setFileters] = useState({categories:[],manufacturers:[],prices:{min:null,max:null}, characteristics:{char_ids:[], values:[]}});
    const [vitrines,setVitrines] = useContext(VitrineContext);
    const { t } = useTranslation();
    const screenHeight = useWindowHeight();
    const loaded = useRef(false);
    const navigator = useNavigate();
    //localStorage.removeItem('filters');

    useEffect(()=>{
        if(!!rayon.id)
        {
            let _filters = {
                ...vitrines.filters,
                categories : filters.categories,
                manufacturers : filters.manufacturers,
                characteristics: filters.characteristics,
                prices:filters.prices,
              };
            if(rayon.id === 28 && !!filters.advanced)
               _filters = {..._filters, advanced: filters.advanced};
            localStorage.setItem('filters',JSON.stringify({'rayon':rayon, 'filters':_filters}));         
        }
    },[filters,rayon]);

    useEffect(()=>{
        if(isBrowser)
        {
            let _filters = {
                ...vitrines.filters,
                categories : JSON.stringify(filters.categories),
                manufacturers : JSON.stringify(filters.manufacturers),
                characteristics: JSON.stringify(filters.characteristics),
                prices:JSON.stringify(filters.prices),
              };
            if(rayon.id === 28 && !!filters.advanced)
               _filters = {..._filters, advanced: JSON.stringify(filters.advanced)};
            setVitrines({...vitrines,articles:[],filters:_filters,page:1});
            try
            {
                vitrines.reload(true);
            }
            catch(e){}
        }
    },[filters.categories, filters.manufacturers, filters.characteristics])
    
    const FetchFilters = async (check_rayon_length=true)=>
    {
        if(rayons.length>0 && check_rayon_length)
            return
        setLoading(true);
        let arr = []
        fetchData.GetData('filter/').then((result)=>{
            if(result.result)
            {
                setRayons(result.rayons);
                let _filters_ = localStorage.getItem('filters');
                console.log('Fetched filters from localStorage', _filters_);
                if (!!_filters_) {
                    _filters_ = JSON.parse(_filters_);
                    console.log('Loaded filters from localStorage', _filters_);
                    result.rayons.forEach((ray) => {
                        if (ray.id === _filters_.rayon.id) 
                        {
                            setRayon(ray);
                            let cat_arr = [];
                            ray.categories.forEach((cat) => 
                            {
                                if (_filters_.filters.categories.includes(cat.id)) 
                                {
                                    cat_arr.push(cat);
                                }
                            }
                            );
                            setCategories([...cat_arr]);
                            let arr = [];
                            cat_arr.forEach((cat)=>{
                                cat.manufacturers.forEach((man)=>{
                                const exist = arr.find(m=>m.id===man.id)
                                if(exist === undefined)
                                {arr.push(man);}})
                            });
                            setManufacturers([...arr]);
                        }
                    });
                    setFileters(_filters_.filters);
                    //console.log('Loaded filters from localStorage', _filters_.filters.categories);
                    //setCategories(_filters_.filters.categories);
                }
                setLoading(false);
                loaded.current = true;
            }

        });
    }
    
    useEffect(()=>{
        setCategories([]);
        setManufacturers([]);
        setRayon({categories:[]});
        FetchFilters(false);
    },[AppState.settings.lang,AppState.settings.devise])
    
    useEffect(()=>{
        if(Categories.length>0)
            setDisplays({...displays,manufacturer:'block'});
        else
            setDisplays({...displays,manufacturer:'none'});
        let arr = [];
        let _harr = []
        Categories.forEach(cat=>{
            arr.push(cat.id); 
        });
        setFileters({...filters,categories:arr});
    },[Categories])

    useEffect(()=>{
        if(rayon.categories.length>0)
            setDisplays({...displays,category:"block"});
        else
            setDisplays({...displays,category:"none"});
    },[rayon.id])

    useEffect(()=>{
        
        if (vitrines.histogram === undefined || vitrines.histogram===null)
            return
        var arr =[];
        Object.keys(vitrines.histogram).forEach((price)=>{
            var pic = {};
            pic[price] = vitrines.histogram[price];
            arr.push(pic);
        }); 
        arr = arr.sort((a,b)=>Number(Object.keys(a)[0])-Number(Object.keys(b)[0]));
        let hists = {};
        if(arr.length>0)
        {
            var key = (2*Number(Object.keys(arr[0])[0])+100)/2;
            hists[key.toString()] = 0
        }
        arr.forEach((hist)=>{
            if(Math.abs(Number(Object.keys(hist)[0])-key) < 50)
            {
                hists[key.toString()] = hists[key.toString()]+ Object.values(hist)[0];
            }
            else
            {
                key = (2*Number(Object.keys(hist)[0])+100)/2;
                hists[key.toString()] = Object.values(hist)[0];
            }
        });
        var chart = [];
        Object.keys(hists).forEach(key=>{
            var pic = {};
            pic[key] = hists[key];
            chart.push(pic);
        });
        setHistograms(chart);
    },[vitrines.histogram])

    
    const HandleManufacturerClick = (man)=>
    {
        const mans = filters.manufacturers ?? [];
        if(!mans.includes(man.id))
        {
            setFileters({...filters, manufacturers: [...mans, man.id]});
        }
        else
        {
            setFileters({...filters, manufacturers: mans.filter(id => id !== man.id)});

        }
    } 

    const ManCheckBox = (man)=>
    {
        let margintop = '2px';
        margintop = isBrowser ? '5px' : '0px';
        return(
        <div style={{display:'block',width:'100%',textAlign:'left',marginTop:'5px',position:'relative'}}>
            <img src={MediaUrl(man.logo.image)} style={{width:'20px',height:'20px',display:'inline-block',borderRadius:'20px',verticalAlign:'middle',marginRight:'10px'}}/>
            <label style={{display:'inline-block',verticalAlign:'middle'}}>{man.name}
            <span style={{color:'gray'}}>{' ('+man.articles.length+')'}</span></label>
            <input checked={((filters.manufacturers??[]).includes(man.id))} onChange={()=>{HandleManufacturerClick(man)}} type='checkbox' style={{position:'absolute',right:'10px',width:'15px',top:'0px',marginTop:margintop,verticalAlign:'middle'}} />
        </div>);
    }

    const MarkedText = (text,count)=>{
        const elements = text.split('*');
        if(elements.length>1)
            return(
                <div style={{display:'flex',flexDirection:'row',justifyItems:'center',alignItems:'center',placeItems:'center'}}>
                    <div>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block'}}>{elements[0]}</label>
                        <label className='filter-cat-label' style={{verticalAlign:'middle',display:'block',fontSize:'xx-small',color:'gray'}}>{elements[1]}</label>
                    </div>
                    <span style={{color:'gray',marginLeft:'10px'}}>{' ('+count+')'}</span>
                </div>
        )
        else{
            return(<div className='filter-cat-label' style={{verticalAlign:'middle',display:'flex',flexDirection:'row'}}><div><label>{text}</label></div>
            <span style={{color:'gray',marginLeft:'10px'}}>{' ('+count+')'}</span></div>)
        }
    }

    const CatCheckBox = (category,count=0,displaycount='none',index)=>
    {
        return(
        <div key={index} style={{position:'relative',display:'block',width:'100%',textAlign:'left',marginTop:'10px'}}>
            {MarkedText(category.name,category.count)}
            <input checked={Categories.includes(category)} onChange={()=>{HandleCategorieClick(category)}} type='checkbox' style={{position:'absolute',right:'10px',width:'15px',top:'0px',verticalAlign:'middle'}} />
        </div>);
    }

    const HandleCategorieClick=(cat,checked)=>
    {
        const cats = Categories;
        if(!Categories.includes(cat))
        {
            setCategories([...Categories,cat]);
            cats.push(cat);
        }
        else
        {
            setCategories([...Categories.filter(c=>c.id!==cat.id)]);
            cats.splice(cats.findIndex(c=>c.id===cat.id),1);
        }
        
        let arr = [];
        cats.forEach((cat)=>{
            cat.manufacturers.forEach((man)=>{
            const exist = arr.find(m=>m.id===man.id)
            if(exist === undefined)
            {arr.push(man);}})
        });
        setManufacturers([...arr]);
    }

    const HandleDisplay=()=>
    {
        if(FilterBtn.display=='none')
        {setFilterBtn({display:'block',text:'-'});}
        else{setFilterBtn({display:'none',text:'+'});}
    }

    const HandleMinMaxChange=(min,max)=>
    {
        //setFilterPrices({min:min,max:max});
    }

    useEffect(()=>{
        console.log(manufacturers);
    },[manufacturers])

    const ApplyFiltres = ()=>
    {
        console.log('Applying filters', filters);
        let _filters = {
            ...vitrines.filters,
            categories : JSON.stringify(filters.categories),
            manufacturers : JSON.stringify(filters.manufacturers),
            characteristics: JSON.stringify(filters.characteristics),
            prices:JSON.stringify(filters.prices),
            };
        if(rayon.id === 28 && !!filters.advanced)
            _filters = {..._filters, advanced: JSON.stringify(filters.advanced)};
        setVitrines({...vitrines,articles:[],filters:_filters,page:1});
        try
        {
            vitrines.reload(true);
        }
        catch(e){}
    }

    const ShowProjectFilters = ()=>
    {
        if(isMobile)
        {
            switch (rayon.name) {
                case 'Photovoltaique':
                    navigator('/photovoltaique/sizing/');
                    break;
                default:
                    break;
            }
        }
    }

    const BtnAdvancedFilter=()=>
    {
        switch (rayon.id) {
            case 28:
                return <Charges rayon={rayon} filters={filters} setFilters={setFileters} />
            default:
                return
        }
    }

    const HandleClickCharacteristic = (char_id, value)=>
    {
        if(!(filters.characteristics.char_ids??[]).includes(char_id))
        {
            setFileters({...filters,characteristics:{char_ids:[...filters.characteristics.char_ids,char_id], values:[...(filters.characteristics.values??[]),value]}})
        }
        else
        {
            setFileters({...filters,characteristics:{char_ids:(filters.characteristics.char_ids??[]).filter(id=>id!==char_id), values:(filters.characteristics.values??[]).filter(v=>v!==value)}})
        }
    }

    const ClearFiltersAndLocalStorage = ()=>
    {
        setFileters({rayon:filters.rayon,categories:[],manufacturers:[], characteristics:{char_ids:[], values:[]}});
        localStorage.removeItem('filters');
        localStorage.removeItem('home_charges');
    }

    const ButtonApply=()=>{
        //if(isMobile)
            return(<div className="FiltresHeader" style={{borderBottom:'1px solid lightgray',position:'sticky',top:'0',marginTop:'-5px',zIndex:'10',backgroundColor:'white',paddingBottom:'10px',marginBottom:'5px'}}>
            <button onClick={()=>{ClearFiltersAndLocalStorage();close();}} style={{border:'none',backgroundColor:'whitesmoke',borderRadius:'5px',height:'25px',width:'55%',display:'inline-block',marginRight:'5px'}}>
                <img style={{height:'90%',verticalAlign:'middle',marginRight:'5px'}} src={clear_filters} />
                <label style={{verticalAlign:'middle',fontSize:'xx-small'}}>{t('ajout-produit.supprimer')}</label>
            </button>
            <div style={{height:'25px',marginTop:'10px',width:'40%',display:'inline-block'}}>
                <ButtonLoader onSubmit={()=>{ApplyFiltres();close();}} style={{backGroundColor:'rgba(246, 223, 91, 0.8)',fontSize:'xx-small'}} text={t('filters.appliquer')}/>
            </div>
            </div>)
        /*
        else
        {
            return(<div className="FiltresHeader" style={{borderBottom:'1px solid lightgray',position:'sticky',top:'0',marginTop:'-5px',zIndex:'10',backgroundColor:'white',paddingBottom:'10px',marginBottom:'5px'}}>
            <button onClick={()=>{ClearFiltersAndLocalStorage();close();}} style={{border:'none',backgroundColor:'whitesmoke',borderRadius:'5px',height:'25px',width:'55%',display:'inline-block',marginRight:'5px'}}>
                <img style={{height:'90%',verticalAlign:'middle',marginRight:'5px'}} src={clear_filters} />
                <label style={{verticalAlign:'middle',fontSize:'x-small'}}>{t('ajout-produit.supprimer')}</label>
            </button>
            <div style={{height:'25px',marginTop:'10px',width:'40%',display:'inline-block'}}>
                <ButtonLoader onSubmit={()=>{ApplyFiltres();close();}} style={{backGroundColor:'rgba(246, 223, 91, 1)',fontSize:'x-small'}} text={t('filters.appliquer')}/>
            </div>
            </div>)
        }*/
    }

    const ClearFileters = ()=>
    {
        setCategories([]);
        setManufacturers([]);
        setFileters({...filters,categories:[],manufacturers:[],characteristics:{char_ids:[], values:[]}});
    }

    var style = {};
    if(isMobile)
        style = {maxHeight:(screenHeight-80-60).toString()+'px'};

    return(
    <div id="FiltresBlock" style={style}>
        {ButtonApply()}
        <fieldset className='FiltresFieldset' style={{maxHeight:'300px',marginBottom:'10px',paddingBottom:'0px'}}>
            <legend>{t('filters.prix')}</legend>
            <Histogram ApplyFilters={ApplyFiltres} histograms={histograms} filters={filters} setFilters={setFileters} />
        </fieldset>
        {BtnAdvancedFilter()}
        <MobileView>
            {
                //<input className='btn-apply-filters' type='button' value={'Appliquer'} style={{border:'none'}}  onClick={(e)=>{ApplyFiltres();close();}} />
            }
            <div id="FiltresTitle" style={{width:'100%',display:'inline-block'}}>
                <div className="BtnDispFilters"><ButtonLoader text={FilterBtn.text} onSubmit={e=>{HandleDisplay()}} style={{backGroundColor:'goldenrod',fontSize:'large',color:'black'}} loading={loading}/></div>
                <span>{t('filters.filtres')}</span>
            </div>
        </MobileView>
        <BrowserView>
            <div id="FiltresTitle">
                <div className="BtnDispFilters"><ButtonLoader text={FilterBtn.text} onSubmit={e=>{HandleDisplay()}} style={{backGroundColor:'goldenrod',fontSize:'large',color:'black'}} loading={loading}/></div>
                <span>{t('filters.filtres')}</span>
            </div>
        </BrowserView>
        <div style={{display:FilterBtn.display}}>
            <fieldset className='FiltresFieldset'>
                <legend>{t('filters.rayons')}</legend>
                {
                    rayons.map((ray,index)=>{
                    return <RayonCheckBox 
                                label={ray.name} 
                                index={index} 
                                rayon={rayon} 
                                setRayon={setRayon} 
                                rayons={rayons} 
                                filters={filters}
                                clearfilters={ClearFileters} 
                                setFileters={setFileters} 
                                img={{disp:true,src:MediaUrl(ray.image)}} 
                                key={ray.name} />})
                }
            </fieldset>

            <fieldset style={{display:displays.category}} className='FiltresFieldset'>
                <legend>{t('filters.categories')}</legend>
                {
                    rayon.categories.map((cat,index)=>
                    {
                        return CatCheckBox(cat,0,HandleCategorieClick,index);
                    })   
                }
            </fieldset>

            {(manufacturers.length>0) && <fieldset style={{}} className='FiltresFieldset'>
                <legend>{t('filters.fabricants')}</legend>
                    {
                        manufacturers.map((man)=>{
                            return(
                                ManCheckBox(man,man.articles.length)
                            )
                        })
                    }           
            </fieldset>}
            
            {Categories.map((cat)=>{
                if(!!cat.characteristics && Object.keys(cat.characteristics).length>0)
                {
                return(
                    <fieldset className='FiltresFieldset' style={{paddingTop:'10px'}}>
                        <legend>{cat.name}</legend>
                            {
                                Object.keys(cat.characteristics).map((_key)=>
                                {
                                    return(<div style={{textAlign:'left',width:'100%'}}>
                                        <label><b>{_key}</b></label>
                                            <hr/>
                                             {Object.keys(cat.characteristics[_key].values).map((key)=>{
                                                return(
                                                    <div style={{textAlign:'left',marginBottom:'5px',position:'relative',width:'100%',display:'flex',flexDirection:'row'}}>
                                                        <div style={{display:'flex',flexDirection:'row'}}><label><i><span>{key}</span></i></label><label><i><span style={{marginLeft:'10px'}}>({cat.characteristics[_key].values[key]})</span></i></label></div> 
                                                        <input checked={(filters.characteristics.char_ids).includes(cat.characteristics[_key].char_id)} onChange={e=>{HandleClickCharacteristic(cat.characteristics[_key].char_id,key)}} style={{position:'absolute',right:'10px',width:'15px'}} type='checkbox' />
                                                    </div>
                                                );
                                             })}
                                        </div>
                                        )      
                                })
                            }
                    </fieldset>
                );
            }
            })}
        </div>
    </div>);
}